const VEHICLE_TYPE = 'vehicleType'
const SERVICE_LIFE = 'serviceLife'
const POWER_ON_HOURS = 'powerOnHours'
const POWER_OFF_HOURS = 'powerOffHours'
const MILEAGE = 'mileage'
const POWER_ON_OFF_CYCLES = 'powerOnOffCycles'

const T_A = 'tA'
const T_J = 'tJ'
const T_PERCENT = 'tPercent'
const T_H = 'tH'

export const MP_FIELDS = [
    VEHICLE_TYPE,
    SERVICE_LIFE,
    POWER_ON_HOURS,
    POWER_OFF_HOURS,
    MILEAGE,
    POWER_ON_OFF_CYCLES
]

export const MP_FIELDS_INT_ATTR = [
    SERVICE_LIFE,
    POWER_ON_HOURS,
    POWER_OFF_HOURS,
    MILEAGE
]

export const CONFIG_TABLE_ATTR = [
    T_A,
    T_J,
    T_PERCENT,
    T_H
]

export const PROJECT_SPEC = 'project.spec.mission_profile'
export const TITLE = PROJECT_SPEC + '.item.label'
export const ADD_POWER_ON = PROJECT_SPEC + '.misc.addPowerOn'
export const ADD_POWER_OFF = PROJECT_SPEC + '.misc.addPowerOff'
export const POWER_ON_BREAKDOWN = PROJECT_SPEC + '.misc.powerOnBreakdown'
export const POWER_OFF_BREAKDOWN = PROJECT_SPEC + '.misc.powerOffBreakdown'
export const REMOVE = 'misc.remove'
export const ADD_MISSION_PROFILE = PROJECT_SPEC + '.misc.add'
export const HEADERS = PROJECT_SPEC + '.misc.headers'

export const POWER_ON_OFF = PROJECT_SPEC + '.item.powerOnOff'
export const T_A_LABEL = POWER_ON_OFF + '.' + T_A
export const T_J_LABEL = POWER_ON_OFF + '.' + T_J
export const T_PERCENT_LABEL = POWER_ON_OFF + '.' + T_PERCENT
export const T_H_LABEL = POWER_ON_OFF + '.' + T_H
